import React, { useState } from "react";
import QuotablesGroup from "./QuotablesGroup";
import Button from "../Button";

export default function WithdrawSampleQuotables({
  withdraw,
  onChange,
  allSampleQuotables,
  onCancelWithdrawal
}) {
  const setReason = reason => {
    onChange({ ...withdraw, reason });
  };

  const sampleQuotables = allSampleQuotables.filter(sq =>
    withdraw.sample_quotable_ids.includes(sq.id)
  );

  const quotables = sampleQuotables.map(sq => sq.quotable);

  return (
    <div className="withdrawing-sample-quotables">
      <div className="pull-right">
        <Button title="Cancel Withdrawal" small onClick={onCancelWithdrawal} />
      </div>
      <h4>The following items will be withdrawn:</h4>
      Enter reason for withdrawing {sampleQuotables.length} items:
      <input
        type="text"
        className="form-control"
        value={withdraw.reason}
        onChange={e => setReason(e.target.value)}
        placeholder="Enter reason here..."
      />
      <QuotablesGroup
        selectSampleQuotables
        hideSearch
        quotables={quotables}
        canSelect={() => false}
      />
    </div>
  );
}
